const ACTIVE_STATUSES = new Set([
    "SETUP_TASK",
    "PENDING",
    "GENERATING_MESSAGE",
    "IN_PROGRESS",
    "PROCESSING",
    "FILE_PROCESSING",
    "READY_TO_CALCULATE",
    "CALCULATING",
    "REPORT_IN_PROGRESS",
    "NOTIFICATION_IN_PROGRESS",
])

const STATUS_PRESENTATION = {
    SETUP_TASK: ["Preparando", "#4169E1"],
    PENDING: ["Pendente", "#E3A107"],
    GENERATING_MESSAGE: ["Preparando mensagens", "#4169E1"],
    IN_PROGRESS: ["Em progresso", "#4169E1"],
    PROCESSING: ["Processando", "#4169E1"],
    FILE_PROCESSING: ["Processando arquivo", "#4169E1"],
    EXCEEDED_RETRIES: ["Retentativas excedidas", "#D32F2F"],
    PROCESS_DONE: ["Concluído", "#2E7D32"],
    DONE: ["Concluído", "#2E7D32"],
    ERROR: ["Erro", "#D32F2F"],
    FILE_ERROR: ["Erro no arquivo", "#D32F2F"],
    READY_TO_CALCULATE: ["Pronto para calcular", "#4169E1"],
    CALCULATING: ["Calculando", "#4169E1"],
    CALCULATE_DONE: ["Calculado", "#2E7D32"],
    REPORT_IN_PROGRESS: ["Gerando relatório", "#4169E1"],
    REPORT_DONE: ["Relatório concluído", "#2E7D32"],
    NOTIFICATION_IN_PROGRESS: ["Enviando notificação", "#4169E1"],
    NOTIFICATION_DONE: ["Notificação concluída", "#2E7D32"],
}

export const WORKFLOW_STATUS_OPTIONS = [
    {value: "", label: "Todos os status"},
    {value: "PENDING", label: "Pendente"},
    {value: "IN_PROGRESS", label: "Em progresso"},
    {value: "PROCESSING", label: "Processando"},
    {value: "CALCULATING", label: "Calculando"},
    {value: "REPORT_IN_PROGRESS", label: "Gerando relatório"},
    {value: "PROCESS_DONE", label: "Concluído"},
    {value: "REPORT_DONE", label: "Relatório concluído"},
    {value: "ERROR", label: "Erro"},
]

export const CONTRACT_VERSION_OPTIONS = [
    {value: "", label: "Todos os contratos"},
    {value: "v1", label: "V1"},
    {value: "v2", label: "V2"},
]

export const safeJsonObject = (value) => {
    if (value && typeof value === "object" && !Array.isArray(value)) return value
    if (typeof value !== "string" || !value.trim()) return {}
    try {
        const parsed = JSON.parse(value)
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {}
    } catch (_) {
        return {}
    }
}

export const clampProgress = (value) => {
    const numeric = Number(value)
    if (!Number.isFinite(numeric)) return 0
    return Math.min(100, Math.max(0, numeric))
}

export const normalizeWorkflowExecution = (execution = {}) => {
    const metadataInput = safeJsonObject(execution.metadata_input ?? execution.metadata)
    const progressTotal = Math.max(0, Number(execution.progress_total ?? execution.total_registros ?? 0) || 0)
    const rawProcessed = Math.max(
        0,
        Number(execution.progress_processed ?? execution.total_registros_processados ?? 0) || 0
    )
    const progressProcessed = Math.min(rawProcessed, progressTotal || rawProcessed)
    const calculatedPercent = progressTotal > 0 ? (progressProcessed * 100) / progressTotal : 0
    const contractVersion = execution.contract_version || "v1"

    return {
        ...execution,
        id: execution.id,
        dag_id: execution.dag_id || execution.rotina || "",
        run_id: execution.run_id || execution.external_workflow_id || null,
        contract_version: contractVersion,
        workflow_group: execution.workflow_group || execution.rotina_grupo || null,
        reference_date:
            execution.reference_date || execution.data_referencia || metadataInput.data_referencia || null,
        current_stage: execution.current_stage || execution.etapa_atual || null,
        progress_total: progressTotal,
        progress_processed: progressProcessed,
        progress_percent: clampProgress(execution.progress_percent ?? calculatedPercent),
        heartbeat_at: execution.heartbeat_at || execution.heartbeat_em || null,
        created_by: execution.created_by ?? execution.criado_por ?? null,
        created_by_name: execution.created_by_name || execution.nome_usuario || null,
        metadata_input: metadataInput,
        metadata_output: safeJsonObject(execution.metadata_output),
        current_error: execution.current_error || null,
        created_at: execution.created_at || execution.criado_em || null,
        updated_at: execution.updated_at || execution.atualizado_em || null,
        capabilities: execution.capabilities || {
            detailed_progress: contractVersion === "v2",
            structured_errors: contractVersion === "v2",
            legacy_report: Boolean(execution.report_path),
        },
        stages: Array.isArray(execution.stages) ? execution.stages : [],
        errors: Array.isArray(execution.errors) ? execution.errors : [],
    }
}

export const isWorkflowActive = (execution) => ACTIVE_STATUSES.has(execution?.status)

export const shouldPollWorkflows = (executions, drawerOpen, visibilityState = "visible") =>
    visibilityState === "visible" && (Boolean(drawerOpen) || executions.some(isWorkflowActive))

export const workflowStatusPresentation = (status) => {
    const [text, color] = STATUS_PRESENTATION[status] || [status || "Não informado", "#667085"]
    return {text, color}
}

export const formatWorkflowDateTime = (value) => {
    if (!value) return "—"
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString("pt-BR", {timeZone: "America/Sao_Paulo"})
}
